import { useState } from "react";
import { Col, Container, Row, Card, CardBody } from "reactstrap";
import Breadcrumbs from "../../../Helper/Breadcrumbs";
import { Button } from "react-bootstrap";
import Search from "../../../Helper/CustomSearch";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import config from "../../../../config";
import { toastAttr } from "../../OfflineLeads/utils";
import { get } from "axios";
import CityEditor from "./form";

const CityContent = () => {
  // ✅ Renamed to PascalCase
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  const tokenKey = {
    headers: { Authorization: "Token " + sessionStorage.getItem("tokenKey") },
  };

  const setLoader = (val) => {
    setLoading(val);
  };

  const renderOnSearch = (searchTerm) => {
    setLoader(true);
    get(`${config.service}/accounts/user/list/?&search=${searchTerm}`, tokenKey)
      .then((res) => {
        console.log(res);
        setLoader(false);
      })
      .catch((err) => {
        if (err.response?.status === 401) window.location.href = "/";
        setLoader(false);
        toast.error("Search Failed", toastAttr);
      });
  };

  const breadcrumbData = [
    { title: "seobook", href: "/seobook" },
    { title: "City Content Editor", href: "#" },
  ];

  const renderForm = (row) => {
    if (row) {
      history.push({
        pathname: "citycontent/citycontentform",
        state: { id: row.id, editMode: true },
      });
    } else {
      history.push({ pathname: "citycontent/citycontentform" });
    }
  };

  return (
    <Container className="vendor">
      <Row>
        <Col md={12} className="contBody">
          <Card>
            <CardBody>
              <div className="card__title pageNav">
                <div className="bold-text">
                  <Breadcrumbs data={breadcrumbData} />
                </div>

                <div className="">
                  <Col md={12}>
                    <CityEditor setLoader={setLoader} loading={loading} />
                  </Col>
                </div>
              </div>
              {/* <Row className="formBtnsDiv mar-b-10">
                <Col md={8}>
                  <Button variant="primary" onClick={() => renderForm()}>
                    Create
                  </Button>
                </Col>
                <Col md={4}>
                  <Search callbackFn={renderOnSearch} />
                </Col>
              </Row> */}
            </CardBody>
          </Card>
        </Col>
      </Row>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Container>
  );
};

export default CityContent; // ✅ Export with the same name
